// PayoutsList — table of CreatorAttribution rows with commission status.
import React from 'react';
import { B } from '../constants';

const STATUS_COLOR = {
  PENDING:  '#f5a623',
  APPROVED: '#0ea5e9',
  PAID:     '#1a6b4a',
  REJECTED: '#dc3545',
  CLAWED_BACK: '#dc3545',
};

function formatMoney(cents, currency) {
  const v = (Number(cents) || 0) / 100;
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(v);
  } catch {
    return `$${v.toFixed(2)}`;
  }
}

function formatDate(d) {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString(); } catch { return '—'; }
}

export default function PayoutsList({ payouts }) {
  if (!payouts || payouts.length === 0) {
    return (
      <p style={{ color: B.muted, fontFamily: "'Montserrat',sans-serif" }}>
        No attributed bookings yet.
      </p>
    );
  }
  return (
    <div style={{
      background: '#fff', borderRadius: 12, overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: "'Montserrat',sans-serif" }}>
        <thead>
          <tr style={{ background: B.sand, color: B.muted, fontSize: 11, textTransform: 'uppercase', letterSpacing: 1 }}>
            <th style={{ textAlign: 'left', padding: '10px 12px' }}>Booking</th>
            <th style={{ textAlign: 'left', padding: '10px 12px' }}>Status</th>
            <th style={{ textAlign: 'right', padding: '10px 12px' }}>Sale</th>
            <th style={{ textAlign: 'right', padding: '10px 12px' }}>Commission</th>
            <th style={{ textAlign: 'right', padding: '10px 12px' }}>Booked</th>
          </tr>
        </thead>
        <tbody>
          {payouts.map((p) => (
            <tr key={p.id} style={{ borderTop: `1px solid ${B.sand}` }}>
              <td style={{ padding: '10px 12px' }}>
                <div style={{ color: B.night, fontWeight: 600, fontSize: 14 }}>
                  {p.booking?.productName || `Booking #${p.bookingId}`}
                </div>
                <div style={{ color: B.muted, fontSize: 12 }}>
                  {p.booking?.partner}{p.booking?.destination ? ` · ${p.booking.destination}` : ''}
                </div>
              </td>
              <td style={{ padding: '10px 12px', fontSize: 12 }}>
                <span style={{
                  background: STATUS_COLOR[p.commissionStatus] || B.muted,
                  color: 'white', padding: '2px 8px', borderRadius: 999, fontWeight: 700,
                  letterSpacing: 0.5,
                }}>
                  {p.commissionStatus}
                </span>
              </td>
              <td style={{ textAlign: 'right', padding: '10px 12px', color: B.night, fontSize: 13 }}>
                {p.booking ? formatMoney(p.booking.amountCents, p.booking.currency) : '—'}
              </td>
              <td style={{ textAlign: 'right', padding: '10px 12px', color: B.night, fontSize: 13, fontWeight: 700 }}>
                {formatMoney(p.commissionCents, p.booking?.currency)}
              </td>
              <td style={{ textAlign: 'right', padding: '10px 12px', color: B.muted, fontSize: 12 }}>
                {formatDate(p.booking?.bookedAt || p.createdAt)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export { formatMoney };
